export const BADGE_STATUS_TYPE = {
    NORMAL: 'NORMAL',
    ERROR: 'ERROR',
};
